module.exports = {
  "country": "BG",
  "artist": "Eliza Todorowa & Stojan Jankulow",
  "song": "Water",
  "year": "2007",
  "place": "5",
  "spotify": ""
};